module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('h1', [_vm._v("footer")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-194e42c0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer/index.vue
// module id = 505
// module chunks = 1